import { takeNewest } from 'utils/redux/sagaHelper';

import { FETCH } from './constants';

const createSagaWatcher = (key, saga) =>
    function* watch() {
        yield takeNewest((action) => action.type === FETCH && action.key === key, saga);
    };

export default createSagaWatcher;
